import { Text, } from "@bracket/ui";
import type { ReactNode, } from "react";
import type { SizeVariant, } from "@bracket/ui/types";
import type { DeviceType, } from "@bracket/sharedTypes";

export declare type TabularRasaDefaultAccessorProps = {
	label?: string;
	value: unknown;
	accessorData?: Record<string, any>;
	device: DeviceType;
	textSize?: SizeVariant;
};


export const TabularRasaDefaultAccessor = ({
	label,
	value,
	accessorData = {},
	device,
	textSize,
}: TabularRasaDefaultAccessorProps): ReactNode => {

	const displayValue: string = typeof value === "string" ? value : typeof value === "number" ? value.toString() : typeof value === "boolean" ? value.toString() : typeof value === "object" && value !== null ? JSON.stringify(value) : String(value ?? "");

	switch(device) {
		case "DESKTOP":
		case "TABLET":
			return <Text size={textSize}>{displayValue}</Text>;
		case "MOBILE":
			return <Text size={textSize}>{displayValue}</Text>;
		default:
			return <Text size={textSize}>{displayValue}</Text>;
	}
};
